import { Icon } from '@chakra-ui/react'
import { FaGoogle } from 'react-icons/fa'

export const Google = props => <Icon as={FaGoogle} {...props} />
